import { WizardComponent } from './admin/wizard/wizard.component';
import { LanguageService } from './services/language.service';
import { CategoryService } from './services/category.service';
import { AuthService } from './services/auth.service';
import { IsLoggedInGuard } from './guards/is-logged-in.guard';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';

import { FullComponent } from './layouts/full/full.component';

import { NavigationComponent } from './shared/header-navigation/navigation.component';
import { SidebarComponent } from './shared/sidebar/sidebar.component';
import { BreadcrumbComponent } from './shared/breadcrumb/breadcrumb.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { PERFECT_SCROLLBAR_CONFIG, PerfectScrollbarConfigInterface, PerfectScrollbarModule } from 'ngx-perfect-scrollbar';

import { Approutes } from './app-routing.module';
import { AppComponent } from './app.component';
import { SpinnerComponent } from './shared/spinner.component';
import { LoginComponent } from './auth/login/login.component';
import { NotifierService } from 'angular-notifier';
import { ChatComponent } from './shared/chat/chat.component';
import { SessionService } from './services/session.service';
import { TextEditorComponent } from './shared/text-editor/text-editor.component';
import { QuillModule } from 'ngx-quill';
import { PasswordRecoveryComponent } from './auth/password-recovery/password-recovery.component';
import { ResetPasswordComponent } from './auth/reset-password/reset-password.component';
import { HighlightModule } from 'ngx-highlightjs';
import { InputCounterModule } from 'ng4-input-counter';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { SocketIoModule, SocketIoConfig } from 'ngx-socket-io';

import htmlbars from 'highlight.js/lib/languages/htmlbars';
import xml from 'highlight.js/lib/languages/xml';
import { MatStepperModule } from '@angular/material/stepper';
import { ColorPickerModule } from 'ngx-color-picker';
import { NgEventBus } from 'ng-event-bus';
import { JwtInterceptor } from './guards/jwt.interceptor';
import { environment } from '../environments/environment';
import { SafeCodePipe } from './pipes/safe-code.pipe';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatDialogRef, MAT_DIALOG_DATA, MatSnackBarModule } from '@angular/material';
import { ErrorCatchingInterceptor } from './guards/error-catching-interceptor';
import { UserAvailabilityComponent } from './shared/header-navigation/user-availability/user-availability.component';
import { AgentService } from './services/agent.service';
import { LanguageSelectorComponent } from './shared/header-navigation/language-selector/language-selector.component';
import { RetryRequest } from './guards/retry-request.interceptor';
import { ServiceWorkerModule } from '@angular/service-worker';
import { CardTitleModule } from './shared/report/resources/card-title/card-title.module';
import { AppVersionComponent } from './shared/app-version/app-version.component';
import { ClipboardModule } from 'ngx-clipboard';

export function hljsLanguages() {
  return [
    { name: 'htmlbars', func: htmlbars },
    { name: 'xml', func: xml }
  ];
}

export function createHttpLoader(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true,
  wheelSpeed: 2,
  wheelPropagation: true
};

const material = [
  MatSnackBarModule,
]

/**
 * WEBSOCKET REFERENCE
 *
 */
const wssconfig: SocketIoConfig = {
  url: environment.socketsURL,
  options: {
    transports: ["websocket"],
    reconnection: true,
    autoConnect: true
  }
}
@NgModule({
  declarations: [
    LanguageSelectorComponent,
    UserAvailabilityComponent,
    AppComponent,
    SpinnerComponent,
    FullComponent,
    NavigationComponent,
    BreadcrumbComponent,
    SidebarComponent,
    LoginComponent,
    ChatComponent,
    TextEditorComponent,
    PasswordRecoveryComponent,
    ResetPasswordComponent,
    WizardComponent,
    SafeCodePipe,
    AppVersionComponent,
  ],
  imports: [
    ...material,
    ClipboardModule,
    CardTitleModule,
    CommonModule,
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    HttpClientModule,
    NgbModule,
    RouterModule.forRoot(Approutes),
    PerfectScrollbarModule,
    QuillModule,
    MatStepperModule,
    ReactiveFormsModule,
    ColorPickerModule,
    MatProgressSpinnerModule,
    HighlightModule.forRoot({
      languages: hljsLanguages
    }),
    InputCounterModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createHttpLoader,
        deps: [HttpClient]
      }
    }),
    SocketIoModule.forRoot(wssconfig),
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production })
  ],
  providers: [
    AgentService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: RetryRequest,
      multi: true
    },
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorCatchingInterceptor,
      multi: true
    },

    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
    },
    { provide: MAT_DIALOG_DATA, useValue: {} },
    { provide: MatDialogRef, useValue: {} },
    IsLoggedInGuard,
    AuthService,
    CategoryService,
    NotifierService,
    SessionService,
    LanguageService,
    NgEventBus
  ],
  entryComponents: [
    TextEditorComponent,
    WizardComponent
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
